<!-- eslint-disable vue/no-duplicate-attributes -->
<template>
  <div class="view-container">
    <div class="header">
      <div class="tab">
        <span
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="handleTabClick(0)"
        >
          海运
        </span>
        <span
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="handleTabClick(1)"
        >
          空运
        </span>
      </div>
      <div class="optheader">
        <!-- 导出按钮 -->
        <div
          v-permission="'export'"
          class="btn flex_c_c"
          style="margin-right: 12px"
          @click="handleExport"
        >
          <i class="el-icon-download" />
          导出
        </div>

        <!-- 搜索过滤器 -->
        <BaseFilter
          :is-active="isActive"
          :width="466"
          @sendFilter="handleSearchOk"
          @reset="handleSearchReset"
        >
          <div class="filter">
            <el-form ref="searchForm" :model="searchData" label-width="70px">
              <el-form-item label="客户">
                <el-select
                  v-model="searchData.companyId"
                  style="width: 310px"
                  filterable
                  multiple
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="搜索">
                <el-input
                  v-model="searchData.search"
                  placeholder="提单号"
                  style="width: 320px"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </BaseFilter>
      </div>
    </div>

    <div class="data">
      <el-tabs
        v-model="title"
        v-loading="loading"
        type="border-card"
        class="el-tabs"
        @tab-click="handleTabClick"
      >
        <!-- 所有7501 -->
        <el-tab-pane :label="'所有(' + form.all + ')'" name="All">
        </el-tab-pane>

        <!-- 待上传7501 -->
        <el-tab-pane :label="'待审预报(' + form.one + ')'" name="PendingReview">
        </el-tab-pane>

        <!-- 待确认7501 -->
        <el-tab-pane
          :label="'待发预报(' + form.two + '）'"
          name="ToBeDispatched"
        >
        </el-tab-pane>

        <!-- 已确认 -->
        <el-tab-pane :label="'已发美国(' + form.three + '）'" name="SentUS">
        </el-tab-pane>

        <!-- 已拒绝 -->
        <el-tab-pane :label="'作废(' + form.four + '）'" name="Cancel">
        </el-tab-pane>

        <div class="table">
          <BaseTable
            :height="height"
            :table-data="{
              ...list,
              fileds,
            }"
            :page-number="pager.PageIndex"
            :page-size="pager.PageSize"
            @handlePageChange="handlePageChange"
            @dblclick="handleRowDoubleClick"
            @selection-change="handleSelectionChange"
          >
            <template slot="opt" slot-scope="row">
              <el-popover
                :ref="`popover${row.scope.id}`"
                placement="bottom-start"
                popper-class="pop-table-opt"
                width="114"
                trigger="click"
              >
                <div class="table-opt">
                  <div
                    v-if="
                      row.scope.status == 5 ||
                        row.scope.status == 4 ||
                        row.scope.status == 3 ||
                        row.scope.status == 2
                    "
                  >
                    <el-button
                      class="opt-item"
                      @click="handleCommand('view', row.scope)"
                    >查看审单</el-button
                    >
                  </div>
                  <div
                    v-if="
                      row.scope.status == 0 ||
                        row.scope.status == 1 ||
                        row.scope.status == 6
                    "
                  >
                    <el-button
                      class="opt-item"
                      @click="handleCommand('documentReview', row.scope)"
                    >审单</el-button
                    >
                  </div>
                  <div
                    v-if="
                      row.scope.status == 2 ||
                        row.scope.status == 3 ||
                        row.scope.status == 4 ||
                        row.scope.status == 5 ||
                        row.scope.status == 6 ||
                        row.scope.status == 7
                    "
                  >
                    <el-button
                      class="opt-item"
                      @click="handleCommand('returnForReview', row.scope)"
                    >退回重审</el-button
                    >
                  </div>
                  <div
                    v-if="
                      row.scope.status == 0 ||
                        row.scope.status == 1 ||
                        row.scope.status == 6
                    "
                  >
                    <el-button
                      class="opt-item"
                      @click="handleCommand('cancel', row.scope)"
                    >作废</el-button
                    >
                  </div>
                  <div v-if="row.scope.status == 2 || row.scope.status == 3">
                    <el-button
                      class="opt-item"
                      @click="handleCommand('sentUSEmail', row.scope)"
                    >发送美国</el-button
                    >
                  </div>
                  <div v-if="row.scope.status == 4">
                    <el-button
                      class="opt-item"
                      @click="handleCommand('sentUSEmail', row.scope)"
                    >重发</el-button
                    >
                  </div>
                </div>
                <img slot="reference" src="@/assets/images/table/opt.png" />
              </el-popover>
            </template>
            <template slot="fileNumber" slot-scope="row">
              <i
                class="el-icon-folder-opened"
                style="color: black"
                @click="viewFile(row.scope)"
              >{{ row.scope.fileNumber }}</i
              >
            </template>
          </BaseTable>
        </div>
      </el-tabs>
    </div>

    <!-- 发送邮件弹窗 -->
    <el-dialog
      class="dialog"
      :visible.sync="dialogFormVisible"
      :title="'发送美国'"
      :destroy-on-close="false"
      :before-close="sentUSDialogClose"
      width="36%"
      top="5vh"
    >
      <el-form
        ref="form2"
        v-loading="loading"
        :model="form2"
        :rules="rules2"
        label-width="100px"
      >
        <el-form-item label="清关行：" prop="supplierClearenceId">
          <el-select
            v-model="form2.supplierClearenceId"
            style="width: 100%"
            filterable
            clearable
            placeholder="请输入选择清关行"
            @change="supplierCodeChange"
          >
            <el-option
              v-for="item in supplierOptions"
              :key="item.id"
              :label="item.code + '-' + item.wbName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Email To" prop="receiver">
          <el-input
            v-model="form2.receiver"
            type="textarea"
            autosize
            autocomplete="off"
            :autosize="{ minRows: 1, maxRows: 4 }"
          />
        </el-form-item>

        <el-form-item label="CC：">
          <el-input
            v-model="form2.cc"
            type="textarea"
            autosize
            autocomplete="off"
            placeholder="请输入电子邮件地址"
            :autosize="{ minRows: 1, maxRows: 4 }"
            @blur="validateEmailList"
          />
        </el-form-item>
        <span v-if="validationError" style="color: red">{{
          validationError
        }}</span>

        <el-form-item label="主题" prop="title">
          <el-input
            v-model="form2.title"
            type="textarea"
            autosize
            show-word-limit
            :autosize="{ minRows: 1, maxRows: 4 }"
          />
        </el-form-item>

        <el-form-item label="正文" prop="content">
          <el-input
            v-model="form2.content"
            type="textarea"
            autosize
            show-word-limit
            :autosize="{ minRows: 3, maxRows: 5 }"
          />
        </el-form-item>

        <el-form-item label="请勾选需要发送的文件" label-width="240">
          <Table
            ref="customTable"
            :tableData="tableData1"
            :height="190"
            :pageFooter="false"
            @selectionchange="selectionchange2"
          >
            <template slot-scope="row">
              <el-button type="text" size="mini">
                <span
                  style="font-size: 12px"
                  @click="download(row.scope)"
                >下载</span
                >
              </el-button>
              <el-button
                v-if="
                  ['.pdf', '.PDF', '.JPG', '.jpg'].includes(row.scope.suffix)
                "
                type="text"
                style="font-size: 12px"
                @click="preview(row.scope)"
              >
                预览
              </el-button>
            </template>
          </Table>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer"
        style="display: contents; margin-top: -30px"
      >
        <el-button @click="sentUSDialogClose">取 消</el-button>
        <el-button
          v-loading="loading"
          type="primary"
          @click="submitForm"
        >发 送</el-button
        >
      </span>
    </el-dialog>

    <ClearenceFileDialog
      :rowData="rowData"
      :dialogVisible="dialogVisible1"
      @cancel="dialogVisible1 = false"
    >
    </ClearenceFileDialog>
    <DetailDrawer
      :drawer="drawer1"
      :billType="active"
      :rowData="rowData"
      @close="drawer1 = false"
    ></DetailDrawer>
    <EditForecaseDrawer
      :drawer="drawer2"
      :mblType="active"
      :rowData="rowData"
      :controlOverInvoicesId="rowData.id"
      :isCheck="isCheck"
      @ok="ok"
      @close="close"
    >
    </EditForecaseDrawer>
  </div>
</template>

<script>
// --- 组件引入 ---
const Table = () => import('@/components/table/table.vue')
const BaseTable = () => import('@/components/table/BaseTable.vue')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const ClearenceFileDialog = () =>
  import('@/views/system/components/ClearenceFileDialog.vue')
const DetailDrawer = () => import('@/views/bill/components/DetailDrawer.vue')
const EditForecaseDrawer = () =>
  import('@/components/drawer/EditForecaseDrawer.vue')
// --- API 导入 ---
import {
  getControlOverInvoicesPagedList,
  returnForRetrial,
  cancel,
  getMBLFileAnOrDoList,
  sentUS,
  downLoadMBLFile
} from '@/api/bill'
import { getSupplierDropDownList } from '@/api/system'
import { derive } from '@/utils/common'
import { mapState, mapGetters } from 'vuex'
import { validateArrEmail } from '@/utils/validate'

export default {
  name: 'InvoiceView', // 添加组件名称
  components: {
    Table,
    BaseTable,
    BaseFilter,
    ClearenceFileDialog,
    DetailDrawer,
    EditForecaseDrawer
  },
  data() {
    return {
      isActive: false, // 搜索过滤器是否激活
      active: 0, // 当前激活的标签页 (0: 海运, 1: 空运)
      rowData: {},
      mblIds: [], // 选中的 MBL ID 数组
      multipleSelection: [], // 多选的行数据
      supplierOptions: [],
      filePaths: {},
      validationError: '',
      drawer1: false, // 提单详情的可见性
      drawer2: false, // 审单页面弹窗可见性
      isCheck: false, // 审单页面弹窗查看可见性
      dialogVisible1: false, // 清关文件弹窗可见性
      dialogFormVisible: false, // 发送美国邮件弹窗可见性
      tableData: {
        fileds: [],
        columns: [],
        total: 0
      },
      tableData1: {
        fileds: [
          { filed: 'fileName', label: '文件名', width: '' },
          { filed: 'typeName', label: '类型', width: '100' },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: '140',
            formatter: (row) =>
              row.createdOn?.substring(0, 16).replace('T', ' ') || ''
          },
          { filed: 'createdName', label: '上传人', width: '100' },
          { filed: 'opt', label: '操作', width: '100' }
        ],
        columns: [],
        total: 0,
        isShowIndex: false,
        isselection: true
      },
      pager: {
        PageIndex: 1,
        PageSize: 20,
        QueryParam: {
          SortField: 'eta',
          SortBy: 0
        }
      },
      searchData: {
        search: '',
        mblNo: '',
        containerNo: '',
        ETA: '',
        isHold: 'all',
        companyId: []
      },
      title: 'All',
      tabNumer: [],
      form: {
        all: 0,
        one: 0,
        two: 0,
        three: 0,
        four: 0
      },
      form2: {
        supplierClearenceId: null,
        mblId: null,
        receiver: null,
        cc: null,
        content: null,
        title: null
      },
      rules2: {
        supplierClearenceId: [
          { required: true, message: '请选择清关行', trigger: 'change' }
        ],
        receiver: [
          { required: true, validator: validateArrEmail, trigger: 'blur' }
        ],
        title: [{ required: true, message: '请填写主题', trigger: 'change' }],
        content: [
          { required: true, message: '请填写邮件内容', trigger: 'change' }
        ]
      },
      rules1: {
        reviewFeedback: [
          { required: true, message: '请输入审单建议', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      loading: false,
      btnloading: false,
      height: 0
    }
  },
  computed: {
    ...mapState({
      deriveLoadingS: (state) => state.deriveLoading
    }),
    ...mapGetters(['companyDrapdown']),
    list() {
      return this.tableData // 直接返回 tableData
    },
    companyOptions() {
      return this.companyDrapdown
    },
    fileds() {
      const arr = [
        {
          filed: 'opt',
          label: '',
          width: '50px',
          isCustom: true,
          fixed: 'left'
        },
        {
          filed: 'companyName',
          label: '客户',
          width: '95'
        },
        {
          filed: 'mblNo',
          label: '主提单号',
          width: '160'
        },
        {
          filed: 'blNo',
          label: '分单号',
          width: '140'
        },
        {
          filed: 'eta',
          label: 'ETA',
          width: '95'
        },
        {
          filed: 'customsClearanceCode',
          label: '清关港',
          width: '75'
        },
        {
          filed: 'qty',
          label: '件数',
          width: '55',
          formatter: function(row) {
            if (row.qty === 0) {
              return ''
            }
            return row.qty
          }
        },
        {
          filed: 'cargoValue',
          label: '货值',
          width: '90'
        },
        {
          filed: 'isHold',
          label: '查验',
          width: '50',
          formatter: (row) => {
            return row.isHold === false || row.isHold === null ? '否' : '是'
          }
        },
        {
          filed: 'fileNumber',
          label: '文件',
          width: '80',
          isCustom: true
        },
        {
          filed: 'importerName',
          label: 'Importer',
          width: '160'
        },
        {
          filed: 'supplierClearence',
          label: '清关行',
          width: '160'
        },
        {
          filed: 'remark',
          label: '备注',
          width: '120'
        },
        {
          filed: 'entryDate',
          label: '进入时间',
          width: '100'
        },
        {
          filed: 'releaseDate',
          label: '放行时间',
          width: '100'
        },
        {
          filed: 'sentUSOn',
          label: '发送时间',
          width: '100'
        },
        {
          filed: 'entryNo',
          label: 'EntryNo',
          width: '120'
        },
        // {
        //   filed: 'firstName',
        //   label: '跟进人',
        //   width: '100'
        // },
        {
          filed: 'sentUSName',
          label: '预报发送人',
          width: '100'
        }
      ]

      const containerNo = {
        filed: 'containerNo',
        label: '柜号',
        width: '120'
      }

      const statuObj = {
        filed: 'statusName',
        label: '状态',
        width: '100'
      }

      if (this.active === 0) {
        arr.splice(3, 0, containerNo)
      }
      if (
        this.status === '0' ||
        this.status === undefined ||
        this.status === ''
      ) {
        arr.splice(0, 0, statuObj) // 插入到索引 7
      }

      return arr
    }
  },
  watch: {
    deriveLoadingS(newVal) {
      this.btnloading = newVal
    }
  },
  created() {
    this.initList()
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 120
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  methods: {
    async download(v) {
      try {
        const res = await downLoadMBLFile({ guid: v.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    /** 提交发送邮件 */
    async submitForm() {
      this.validateEmailList()
      if (this.validationError) return
      if (this.multipleSelection.length < 1) {
        return this.$message.error('请选择至少1个附件文件')
      }

      try {
        await this.$refs.form2.validate()
        this.loading = true

        // 确保 filePaths 是最新的 (防御性编程)
        this.filePaths = this.multipleSelection.reduce((acc, item) => {
          acc[item.fileName] = item.filePath
          return acc
        }, {})

        const items = {
          ...this.form2,
          id: this.rowData.id,
          filePaths: this.filePaths
        }
        const res = await sentUS(items)

        if (res.success) {
          this.$message.success(`发送成功`)
          this.sentUSDialogClose()
          this.searchList()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error('提交失败:', error)
      } finally {
        this.loading = false
      }
    },
    /** 选择文件变更 */
    selectionchange2(val) {
      this.filePaths = val.reduce((acc, item) => {
        acc[item.fileName] = item.filePath
        return acc
      }, {})
      this.multipleSelection = val
    },
    async getSupplierDropDownList() {
      try {
        const param = {
          scopValue: 18
        }
        const res = await getSupplierDropDownList(param)
        if (res.success) {
          this.supplierOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    /** 清关行改变 */
    supplierCodeChange(val) {
      const supplier = this.supplierOptions.find((item) => item.id === val)
      this.form2.receiver = supplier?.email || ''
      this.form2.cc = supplier?.email || ''
    },

    /** 邮箱列表验证 */
    validateEmailList() {
      this.validationError = ''
      const cc = this.form2.cc?.trim() || ''

      if (cc.includes(' ')) {
        this.validationError = '电子邮件地址中不能包含空格'
        return
      }

      if (!cc) return

      const emails = cc
        .split(/[,;，；]/)
        .filter((email) => email.trim() !== '')
      for (const email of emails) {
        if (!this.isValidEmail(email.trim())) {
          this.validationError = '电子邮件格式不正确'
          return
        }
      }
    },

    /** 单个邮箱验证 */
    isValidEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailRegex.test(email.trim())
    },
    /**
     * 初始化列表数据
     */
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20,
        QueryParam: {
          mblType: this.active,
          title: this.title === 'All' ? undefined : this.title,
          SortField: 'eta',
          SortBy: 0
        }
      }
      this.pager = param
      this.getList(param)
      this.getSupplierDropDownList()
    },

    /**
     * 处理标签页切换
     */
    handleTabClick(indexOrEvent) {
      // 如果是点击事件对象，获取索引
      if (typeof indexOrEvent === 'object' && indexOrEvent !== null) {
        // 通常这里处理的是 tab-click 事件，indexOrEvent 本身是事件对象
        // 我们使用 status 作为当前激活的状态
      } else {
        // 这里处理的是 TabhandleClick 方法
        this.active = indexOrEvent
      }
      this.initPage()
      this.searchList()
    },

    /**
     * 处理搜索重置
     */
    handleSearchReset() {
      this.isActive = false
      this.searchData = {
        search: '',
        mblNo: '',
        containerNo: '',
        ETA: '',
        entryDate: '',
        releaseDate: '',
        uploadTaxDate: '',
        companyId: [],
        importerSCINId: '',
        userGroupId: [],
        supplierId: '',
        destinCode: '',
        entryNo: '',
        isHold: 'all',
        totalTaxesMin: '',
        totalTaxesMax: '',
        parentCompanyId: ''
      }
      this.initPage()
      this.searchList()
    },

    /**
     * 处理搜索提交
     */
    handleSearchOk() {
      this.initPage()
      this.searchList()
      this.isActive = true
    },

    /**
     * 初始化分页参数
     */
    initPage() {
      this.pager = {
        PageIndex: 1,
        PageSize: 20
      }
    },

    /**
     * 构造并发送搜索请求
     */
    searchList() {
      const params = {
        ...this.pager, // 展开 pager 对象
        QueryParam: {
          ...this.pager.QueryParam,
          title: this.title === 'All' ? undefined : this.title,
          mblType: this.active,
          Search: this.searchData.search || undefined,
          mblNo: this.searchData.mblNo || undefined,
          companyId: this.searchData.companyId.length > 0 ? this.searchData.companyId : undefined,
          containerNo: this.searchData.containerNo || undefined,
          isHold:
            this.searchData.isHold === 'all'
              ? undefined
              : this.searchData.isHold,
          SortField: 'eta',
          SortBy: 0
        }
      }
      this.getList(params)
    },

    /**
     * 处理分页变化
     */
    handlePageChange(pager) {
      this.pager.PageIndex = pager.pageIndex
      this.pager.PageSize = pager.pageSize
      this.searchList()
    },
    /**
     * 处理行双击事件
     */
    async handleRowDoubleClick(row) {
      await this.$store.dispatch('getAddressBookOptions', {
        type: -1
      })

       this.rowData = {
        ...row,
        id: row.mblId,
        status: row.mblStatus
       }
      this.drawer1 = true
    },

    /**
     * 处理选择变化
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.mblIds = val.map((item) => item.mblId).filter((id) => id) // 过滤掉 undefined/0
      // 注意：如果 id 本身就是 0，需要特殊处理，但根据业务逻辑，一般 id 不会是 0
      // 如果需要，可以改为：val.filter(item => item.id !== undefined && item.id !== null).map(item => item.id)
    },

    /**
     * 处理操作下拉菜单命令
     */
    handleCommand(key, row) {
      switch (key) {
        case 'view':
          this.viewClick(row)
          break
        case 'documentReview':
          this.documentReviewClick(row)
          break
        case 'returnForReview':
          this.returnForReviewClick(row)
          break
        case 'cancel':
          this.cancelClick(row)
          break
        case 'sentUSEmail':
          this.sentUSEmailClick(row)
          break
        default:
          console.warn(`Unknown command: ${key}`)
      }
    },

    async sentUSEmailClick(row) {
      this.resetform2()
      this.rowData = row
      this.form2.mblId = row.mblId
      // 设置默认标题和内容
      this.setMailDefaults(row)

      // 预加载文件列表
      await this.getfileList(row)

      // 设置清关行（如果存在）
      if (
        row.supplierClearenceId &&
        this.supplierOptions.some((opt) => opt.id === row.supplierClearenceId)
      ) {
        this.form2.supplierClearenceId = row.supplierClearenceId
        this.supplierCodeChange(this.form2.supplierClearenceId)
      }

      this.dialogFormVisible = true
    },

    /** 设置邮件默认值 */
    setMailDefaults(row) {
      const isSea = this.active === 0
      const mblPart = `MBL:${row.mblNo}`
      const hblPart = row.blNo ? `, HBL:${row.blNo}` : ''
      const containerPart = isSea ? `, Container:${row.containerNo}` : ''
      const eta = `, ETA:${row.eta}`
      const customsClearanceCode = row.customsClearanceCode
        ? `, Entry Port:${row.customsClearanceCode}`
        : ''

      this.form2.title = `${mblPart}${containerPart}${hblPart}${eta}${customsClearanceCode}`
      this.form2.content = `<p>Please check the customs clearance documents！</p>`
    },

    /** 获取文件列表 */
    async getfileList(row) {
      try {
        const params = { fileSoureCode: undefined, mblId: row.mblId }
        const res = await getMBLFileAnOrDoList(params)
        this.tableData1.columns = (res.data || []).filter(a => {
           return a.uploadType !== 5
          })
      } catch (error) {
        console.error('获取文件列表失败:', error)
        this.tableData1.columns = []
      }
    },

    /** 预览文件 */
    preview(item) {
      window.open(item.filePath)
    },
    /** 重置表单2 (修复了原代码中的 supplierCode 错误) */
    resetform2() {
      this.form2 = {
        supplierClearenceId: null,
        mblId: null,
        receiver: null,
        cc: null,
        content: null,
        title: null
      }
      this.rowData = {}
      this.filePaths = {} // 重置文件路径
    },

    /** 关闭发送邮件弹窗 */
    sentUSDialogClose() {
      this.dialogFormVisible = false
      this.resetform2()
      this.$refs.form2?.resetFields()
    },
    ok(item) {
      if (item !== undefined) {
        this.title = item
      }
      this.searchData.search = this.rowData.mblNo
      this.handleSearchOk()
      this.drawer2 = false
      this.isreviewFeedback = false
    },
    close() {
      this.rowData = {}
      this.drawer2 = false
      this.isCheck = false
      this.isActive = false
      this.dialogFormVisible = false
      this.isreviewFeedback = false
      this.searchList()
    },
    documentReviewClick(row) {
      this.rowData = row
      this.drawer2 = true
    },
    viewClick(row) {
      this.rowData = row
      this.drawer2 = true
      this.isCheck = true
    },
    returnForReviewClick(row) {
      returnForRetrial(row.id).then((res) => {
        if (res.success) {
          this.isActive = true
          this.title = 'PendingReview'
          this.searchData.search = row.mblNo
          this.$message.success('退回重审成功')
          this.handleSearchOk()
        }
      })
    },
    cancelClick(row) {
      cancel(row.id).then((res) => {
        if (res.success) {
          this.isActive = true
          this.title = 'Cancel'
          this.searchData.search = row.mblNo
          this.$message.success('发票已作废')
          this.handleSearchOk()
        }
      })
    },
    /**
     * 处理弹窗关闭
     */
    handleDialogClose() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
      this.dialogVisible = false
    },

    /**
     * 获取列表数据
     */
    getList(params) {
      getControlOverInvoicesPagedList(params)
        .then((res) => {
          if (res.success) {
            // 处理数据格式
            this.tableData.columns = res.data.list.map((item) => ({
              ...item,
              eta: item.eta?.substring(0, 10),
              etd: item.etd?.substring(0, 10),
              entryDate: item.entryDate ? item.entryDate.substring(0, 10) : '',
              releaseDate: item.releaseDate
                ? item.releaseDate.substring(0, 10)
                : '',
              uploadedDate: item.uploadedDate
                ? item.uploadedDate.substring(0, 10)
                : ''
            }))

            this.tableData.total = res.data.total

            // 更新 tab 数字
            this.updateTabNumbers(res.data.tabNumer || [])

            // 保存 tabNumer 供后续使用
            this.tabNumer = res.data.tabNumer || []
          } else {
            this.$message.error(res.errorMessage || '获取列表失败')
          }
        })
        .catch((error) => {
          console.error('Get list error:', error)
          this.$message.error('网络错误，请稍后再试')
        })
    },

    /**
     * 更新 tab 数字统计
     */
    updateTabNumbers(tabNumer) {
      // 初始化所有数值为 0
      this.form.all = 0
      this.form.one = 0
      this.form.two = 0
      this.form.three = 0
      this.form.four = 0

      if (!Array.isArray(tabNumer)) return

      // 只遍历每个 item 的 subTab
      tabNumer.forEach((item) => {
        // 确保 subTab 存在且是数组
        if (Array.isArray(item.subTab)) {
          item.subTab.forEach((subItem) => {
            const { type, qty } = subItem

            // 根据 subItem 的 type 累加到对应字段
            if (type === 0) {
              this.form.one += qty
            } else if (type === 1) {
              this.form.two += qty // ✅ 这里会匹配到你的 type=1
            } else if (type === 2) {
              this.form.three += qty
            } else if (type === 3) {
              this.form.four += qty
            }

            // 累加到总数
            this.form.all += qty
          })
        }
      })
    },

    /**
     * 处理导出按钮点击
     */
    async handleExport() {
      const params = {
        title: this.title === 'All' ? undefined : this.title,
        mblType: this.active,
        Search: this.searchData.search || undefined,
        mblNo: this.searchData.mblNo || undefined,
        containerNo: this.searchData.containerNo || undefined,
        isHold:
          this.searchData.isHold === 'all' ? undefined : this.searchData.isHold
      }

      this.btnloading = true
      try {
        await derive('ControlOverInvoices/export', 'post', params, null)
      } catch (error) {
        console.error('Export error:', error)
        this.$message.error('导出失败')
      } finally {
        this.btnloading = false
      }
    },
    viewFile(row) {
      this.rowData = row
      this.dialogVisible1 = true
    }
  }
}
</script>

<style lang="less" scoped>
.view-container {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;

  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }

    .active {
      color: rgb(18, 88, 188);
    }

    .type-tab {
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      border-radius: 2px 2px 2px 2px;
      overflow: hidden;

      & > span {
        height: 30px;
        padding: 7px 12px;
        box-sizing: border-box;
        background: #f7f7f7;
        cursor: pointer;

        &.active {
          color: #ffffff;
          background: rgb(18, 88, 188);
        }
      }
    }
  }

  .optheader {
    display: flex;

    & > div + div {
      margin-left: 8px;
    }

    .search {
      position: relative;
      display: flex;
      width: 200px;

      .input-search {
        width: 170px;
        height: 30px !important;

        /deep/ .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }

      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        box-sizing: border-box;
        cursor: pointer;
      }
    }

    /deep/ .el-input__inner {
      height: 30px;
    }

    .add {
      width: 84px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgb(18, 88, 188);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
      line-height: 24px;

      .icon {
        font-size: 20px;
      }
    }

    .filter {
      width: 84px;
      height: 32px;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid rgb(18, 88, 188);
      border-color: rgba(35, 149, 243, 0.4);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
      line-height: 24px;
    }
  }

  .opt {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn {
    width: 80px;
    height: 30px;
    background: rgb(18, 88, 188);
    border-radius: 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }

  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }

  .data {
    width: 100%;
    height: calc(100% - 50px);

    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  }

  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }

  .table-opt:deep(.el-button) {
    padding: 0;
  }

  .status {
    width: 28px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 20px;
    margin-left: 5px;
    margin-right: 31px;
  }
}

:deep(.el-upload-dragger) {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 470px;
  height: 100px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

:deep(.el-upload-list) {
  float: none;
}
</style>
